import React from "react";

const clock = (seconds) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

const ReservationTimer = ({ secondsLeft, ttlSeconds }) => {
  const expired = secondsLeft <= 0;
  const progress = ttlSeconds > 0 ? Math.max(0, Math.min(1, secondsLeft / ttlSeconds)) : 0;

  return (
    <div className={`sy-checkout-timer${expired ? " is-expired" : ""}`} role="status">
      <span className="sy-checkout-timer-clock">{expired ? "0:00" : clock(secondsLeft)}</span>

      <div className="sy-checkout-timer-body">
        <p className="sy-checkout-timer-title">
          {expired ? "Reservation expired" : "Your order is reserved"}
        </p>

        <p className="sy-checkout-timer-text">
          {expired
            ? "Reserve again to refresh your items and price."
            : "Your items and price are held until the timer runs out."}
        </p>

        <div className="sy-checkout-timer-track" aria-hidden="true">
          <span
            className="sy-checkout-timer-fill"
            style={{ width: `${Math.round(progress * 100)}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ReservationTimer;
